/**
 * Creates an API error object
 */
const createApiError = (status, message, data = null) => ({
  status,
  message,
  data,
  name: "ApiError",
  isApiError: true,
});

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const fetchApi = async ({
  endpoint = "",
  method = "GET",
  headers = {},
  body = null,
  keepalive = false,
}) => {
  try {
    const cleanEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
    const url = cleanEndpoint.replace(/\/+/g, "/");

    const options = {
      method,
      headers: {
        ...defaultHeaders,
        ...headers,
      },
      keepalive,
    };

    if (body) {
      options.body = typeof body === "string" ? body : JSON.stringify(body);
    }

    const response = await fetch(url, options);

    const result = {
      status: response.status,
      data: null,
    };

    try {
      const contentType = response.headers.get("content-type");
      if (contentType && contentType.includes("application/json")) {
        result.data = await response.json();
      }
    } catch (parseError) {
      console.log("parseError: ", parseError);
    }

    if (!response.ok) {
      throw createApiError(response.status, "An error occurred", result);
    }

    return result;
  } catch (error) {
    if (error.name === "TypeError") {
      throw createApiError(0, "Network error - Failed to fetch");
    }

    // Rethrow API errors or wrap unknown errors
    if (error.isApiError) {
      throw error;
    }

    throw createApiError(500, "Unknown error occurred", error);
  }
};

export const apiGet = (endpoint, options = {}) =>
  fetchApi({ ...options, method: "GET", endpoint });

export const apiPost = (endpoint, body, options = {}) =>
  fetchApi({ ...options, method: "POST", endpoint, body });

export const apiPut = (endpoint, body, options = {}) =>
  fetchApi({ ...options, method: "PUT", endpoint, body });

export const apiDelete = (endpoint, options = {}) =>
  fetchApi({ ...options, method: "DELETE", endpoint });
